<template>
  <!--
  <div class="app flex-row align-items-center"
      :style="{ backgroundImage: 'url(img/background.jpg)' }">
  -->      
  <div class="app app-body flex-row align-items-center">
    <div id="spinner" class="justify-content-center align-items-center"
        :style="{ height: spinnerHeight + 'px', 
          width: spinnerWidth + 'px' }" 
        v-if='procesando'>
      <b-spinner id="spinner-spin" label="Loading...">
      </b-spinner>
    </div>

    <div class="container forgot-pwd">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4 login-card">
              <b-card-body>
                <b-form>
                  <h1>Olvidé mi contraseña</h1>
                  <p class="text-muted">Ingrese sus credenciales de acceso</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text" class="form-control" 
                      v-model="username" 
                      placeholder="Usuario" 
                      autocomplete="username" />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button variant="primary" 
                        class="px-4"
                        @click.prevent="forgotPassword">Enviar instrucciones</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <!-- <b-button variant="link" class="px-0">Olvidé mi contraseña</b-button> -->
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
          <b-alert
            class="alert"
            :show="dismissCountDown"
            dismissible
            fade
            :variant="alertVariant"
            @dismissed="dismissCountDown= 0"
            @dismiss-count-down="countDownChanged">
            <p>{{ alertMsj }}</p>
          </b-alert>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { msjAlert } from '../../mixins/msjAlert';

export default {
  name: 'Forgot',
  mixins: [ 
    msjAlert
  ],
  data () {
    return {
      username: '',
    }
  },
  computed: {
    procesando: {
      get: function () {
        return this.$store.getters['spinnerProcesando/procesando'];
      },
      set: function (newValue) {
      }
    },
    spinnerHeight: {
      get: function () {
        return this.$store.getters['spinnerProcesando/height'];
      },
      set: function (newValue) {
      }
    },
    spinnerWidth: {
      get: function () {
        return this.$store.getters['spinnerProcesando/width'];
      },
      set: function (newValue) {
      }
    },
  },
  methods: {
    forgotPassword () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      // this.$v.$touch()

      // if (this.$v.$anyError) {
      //   this.displayErrores();
      // } else {
        let params = {
            username: this.username,
        }

        this.showSpinner();
        this.$store.dispatch('user/forgotPassword', params)
          .then(() => {
            this.username = '';
            // this.$v.$reset();
            this.showAlert('Se envió un correo a su cuenta con las instrucciones para restablecer su contraseña.', 'info', this.goLogin, 5);
          })
          .catch(error => this.showAlertError(error))
          .finally (() => this.hideSpinner());
      // }
    },
    goLogin() {
      this.$router.push({ name: 'Login' });
    }    
  }
}
</script>

<style>
  .forgot-pwd button.btn-primary {
    width: 180px !important;
  }
</style>